/* TPW CountUp — tiny, native, dependency-free (REF-03 React Bits "CountUp", rebuilt).
   Any element with class `tpw-count` whose text starts with a number animates from 0
   to that number when it scrolls into view (once). Preserves prefix + suffix, e.g.
   "250+" -> counts 0..250 then "+", "$150" -> "$0".."$150", "20+" -> "0+".."20+".
   Robust by design: the FINAL value is the server-rendered text and is only replaced
   the instant we start animating, so if JS fails or is disabled the real number stays.
   Respects prefers-reduced-motion (no animation) and uses one shared IntersectionObserver. */
(function () {
  function parse(text) {
    var s = String(text).trim();
    if (/\d:\d/.test(s)) return null; // skip clock times (e.g. "2:00") — not a count-able stat
    var m = s.match(/^(\D*)(\d[\d,]*)(.*)$/);
    if (!m) return null;
    return { pre: m[1], target: parseInt(m[2].replace(/,/g, ''), 10), suf: m[3], comma: m[2].indexOf(',') !== -1 };
  }
  function fmt(n, comma) { return comma ? n.toLocaleString('en-US') : String(n); }
  function animate(el, info) {
    var dur = 1100, t0 = null;
    el.style.fontVariantNumeric = 'tabular-nums'; // no width jitter while counting (protects CLS/INP)
    function tick(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1);
      var e = 1 - Math.pow(1 - p, 3); // easeOutCubic
      el.textContent = info.pre + fmt(Math.round(info.target * e), info.comma) + info.suf;
      if (p < 1) requestAnimationFrame(tick);
      else el.textContent = info.pre + fmt(info.target, info.comma) + info.suf;
    }
    requestAnimationFrame(tick);
  }
  function run() {
    var els = document.querySelectorAll('.tpw-count:not([data-cu])');
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var info = parse(en.target.textContent);
        if (info) animate(en.target, info);
      });
    }, { threshold: 0.4 }) : null;
    els.forEach(function (el) {
      el.setAttribute('data-cu', '1');
      if (reduce || !io || !parse(el.textContent)) return; // leave the real value in place
      io.observe(el);
    });
  }
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
})();
